import CalendarIcon from "@/assets/colorable/calendar.svg?react";
import InputField from "@/components/Common/forms/InputField";
import clsxm from "@/lib/clsxm";
import {useRef, type FC} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerField: FC<{
  onChange?: (value: Date) => void;
  isDisabled?: boolean;
  error?: string | null | undefined;
  label?: string;
  labelClassName?: string;
  value: Date | null;
  placeholder?: string;
  inputFieldClassName?: string;
  dayClassName?: (date: Date) => string;
  iconClassName?: string;
  minDate?: Date;
  maxDate?: Date;
  showIcon?: boolean;
  dateFormat?: string;
  monthsShown?: number;
}> = ({
  onChange,
  error = null,
  label,
  labelClassName,
  placeholder,
  value,
  inputFieldClassName,
  dayClassName,
  iconClassName,
  isDisabled = false,
  minDate,
  maxDate,
  showIcon = true,
  dateFormat = "dd/MM/yyyy",
  monthsShown = 1,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <DatePicker
      selected={value}
      dateFormat={dateFormat}
      onChange={(date: Date | null) => {
        if (date) {
          onChange?.(date);
        }
      }}
      minDate={minDate || new Date()}
      maxDate={maxDate}
      monthsShown={monthsShown}
      calendarStartDay={1}
      dayClassName={dayClassName}
      customInput={
        <InputField
          className={inputFieldClassName + " w-full flex-1"}
          ref={inputRef}
          error={error}
          value={value?.toString() || null}
          label={label}
          labelClassName={labelClassName}
          placeholder={placeholder}
          isDisabled={isDisabled}
          isReadonly={true}
          icon={
            showIcon &&
            !isDisabled && (
              <button className="absolute top-0 right-0 bottom-0 h-full px-4">
                <CalendarIcon className={clsxm("text-primary-dark-solid size-5 shrink-0", iconClassName)} />
              </button>
            )
          }
        />
      }
    />
  );
};

export default DatePickerField;
